<template>
  <div
    v-masonry-tile
    :class="`insight d-inline-block insight-cols-${this.columns}`"
    style="vertical-align: top; padding: 0 !important; margin: 0 !important;">
    <div :style="innerStyle">
        <slot/>
    </div>
  </div>
</template>

<script>
  import {CATEGORICAL_INSIGHT_HEIGHT} from './utils';

  export default {
    name: 'CategoricalInsightContainer',

    props: {
      columns: {
        type: Number,
        default: 1
      }
    },

    mounted() {
      if (typeof this.$redrawVueMasonry === 'function') {
        this.$redrawVueMasonry()
      }
    },

    computed: {
      innerStyle() {
        const spacing = "20px 4px";
        return {
          height: `${CATEGORICAL_INSIGHT_HEIGHT}px`,
          width: `calc(100% - ${spacing} * 2)`,
          margin: spacing,
          position: "relative"
        };
      }
    }
  };
</script>

<style scoped lang="sass">
  @for $i from 1 through 4
    .insight-cols-#{$i}
      width: $i * 25%
      max-width: 100%

  @media (max-width: 480px)
    @for $i from 1 through 4
      .insight-cols-#{$i}
        width: $i * 50%

  @media (max-width: 320px)
    @for $i from 1 through 4
      .insight-cols-#{$i}
        width: 100%
</style>
